import ActionTypes from '@ziynx/action-types';
import { getActionGroup, getNewFiltersResults } from '@ziynx/components/utilities';
import type { ChannelType } from '@ziynx/flow-types/channel';

type GetDiscoverResponse = Array<
  {
    _id: string,
    title: string, // section title
    data: Array<ChannelType>
  }
>;

type DiscoverAction = {
  type: string,
  response?: GetDiscoverResponse,
  error?: any,
  userInfo?: Object,
}

const initialState = {};

/** HELPER FUNCTION FOR TALENT PROFILE ISWATCHED  */
const getNewSectionResults = (talentId, state, option) => {
  const sectionResults = (state?.results ?? []).map((section) => ({
    ...section,
    results: (section?.results ?? []).map((talent) => {
      if (talent?.profile?._id !== talentId) return talent;

      return {
        ...talent,
        profile: {
          ...talent?.profile,
          isWatched: option !== 'remove',
        },
      };
    }),
  }));

  return sectionResults || [];
};

export default function reduceDiscover(state = initialState, action: DiscoverAction) {
  if (!action.type) {
    return state;
  }

  const actionGroup = getActionGroup(action?.type);

  switch (action?.type) {
  case ActionTypes.discover.get.START:
    return {
      ...state,
      fetching: true,
      success: false,
      error: null,
    };

  case ActionTypes.discover.get.SUCCESS:
    return {
      ...state,
      ...action?.response ?? {},
      fetching: false,
      success: true,
      error: null,
    };

  /* When a MyShot is viewed, this helps reduce number of dispatches.
  Regardless of success or error. */
  case ActionTypes.trackingAction.viewedMyShot.START:
    return {
      ...state,
      viewership: {
        ...state?.viewership,
        [action?.videoViewed]: true,
      },
    };

  /**
   * When add, trigger UI response
   * When remove errors, re-added the checkmark on squircle
   */
  case ActionTypes.watchlist.add.START:
  case ActionTypes.watchlist.remove.ERROR:
    return {
      ...state,
      results: getNewSectionResults(
        action?.userInfo?._id, state, 'add',
      ),
    };

    /**
     * When remove, trigger UI response
     * When add errors, re-added the plus on squircle
     */
  case ActionTypes.watchlist.remove.START:
  case ActionTypes.watchlist.add.ERROR:
    return {
      ...state,
      results: getNewSectionResults(
        action?.userInfo?._id, state, 'remove',
      ),
    };

  case ActionTypes.watchlist.add.SUCCESS: {
    let watchlistData;
    if (state?.watchlist) {
      watchlistData = [...state?.watchlist?.data];
      watchlistData.unshift(action?.userInfo);
    }

    return {
      ...state,
      watchlist: {
        ...state?.watchlist,
        data: watchlistData,
        total: state?.watchlist?.total + 1,
      },
    }; }

  case ActionTypes.watchlist.remove.SUCCESS:
    return {
      ...state,
      watchlist: {
        ...state?.watchlist,
        data: action?.response?.results,
        total: action?.response?.total,
      },
    };

  case ActionTypes.discover.postFilters.START:
    return {
      ...state,
      [actionGroup]: {
        fetching: true,
        success: false,
        error: null,
      },
    };

  case ActionTypes.discover.postFilters.SUCCESS:
    return {
      ...state,
      ...action?.response ?? {},
      filters: action?.response?.filters,
      addedFilters: true,
      [actionGroup]: {
        fetching: false,
        success: true,
        error: null,
      },
    };

  case ActionTypes.filters.removeAll:
    return {
      ...state,
      addedFilters: false,
      filters: {},
    };

  case ActionTypes.filters.remove:
    return {
      ...state,
      filters: getNewFiltersResults(state?.filters ?? {}, action?.filters?.content),
    };

  case ActionTypes.discover.postFilters.ERROR:
    return {
      ...state,
      [actionGroup]: {
        fetching: false,
        success: false,
        error: action?.error,
      },
    };

  case ActionTypes.discover.clearPostFilters:
    return {
      ...state,
      POST_DISCOVER_FILTERS_API: {},
    };

  case ActionTypes.discover.get.ERROR:
    return {
      ...state,
      fetching: false,
      success: false,
      error: action?.error,
    };
  default:
    return state;
  }
}
